module.exports = __webpack_public_path__ + "img/inactive_promoter.aa602453.png";